import createTypes from 'redux-create-action-types';

export const ActGlo = createTypes('EN_COURS_DE_CHARGEMENT', 'RESET_STORE', 'CHANGE_COP_SEL');

export const ActAdh = createTypes('ADH_AJOUT', 'ADH_AVIS_ENVOYE',"ADH_COMPRIS_AIDE");

export const ActCop = createTypes(
    'COP_AJOUT',
    'COP_PROPRIETAIRES_AJOUT',
    'COP_BANQUE_AJOUT',
    'COP_CHARGES_AJOUT',
    'COP_FOURNISSEURS_AJOUT',
    'COP_NUMEXE_MODIF',
);

export const ActDoc = createTypes(
    'DOC_AJOUT',
    'DOC_FILTRE_OBJET',
    'DOC_FILTRE_PREST',
    'DOC_FILTRE_ACT',
    'DOC_FILTRES_SUPPR',
);

export const ActMes = createTypes('MES_CHARGEMENT', 'MES_AJOUT', 'MES_DATE_DEBUT', 'MES_MARQUER_VU_PAR_CLIENT','MES_CHARGE_PRESTATIONS');

export const ActPro = createTypes('PRO_AJOUT', 'PRO_HISTORIQUE_AJOUT', 'PRO_CIVILITES_AJOUT', 'PRO_PAYS_AJOUT');

export const ActSyn = createTypes('SYN_AJOUT');

export const ActVote = createTypes('VOTES_CHOIX', 'VOTES_RECUP', 'VOTES_MAJ');



// WEBPACK FOOTER //
// ./src/App_Data/ActionTypes.js